import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import ChannelsFilter from "@/components/ChannelsFilter";
import { TableHeader } from "@/components/Table";
import { Controls, ControlsButton } from "@/components/Controls";
import { useState } from "react";
import Heatmap from "./components/Heatmap";

const typeTabs = [
  { value: 0, title: "Views" },
  { value: 1, title: "Videos" },
];

const timeTabs = [
  { value: 0, title: "Last week" },
  { value: 1, title: "Last month" },
  { value: 2, title: "Last 3 months" },
];

const DistributionHeatmap = () => {
  const [activeTypeTab, setActiveTypeTab] = useState(typeTabs[0]);

  const [activeTimeTab, setActiveTimeTab] = useState(timeTabs[0]);

  return (
    <>
      <TeamHeading />
      <PageHeading>Heatmap</PageHeading>
      <ChannelsFilter />
      <TableHeader>
        <Controls>
          {typeTabs.map((tab, index) => (
            <ControlsButton
              key={index}
              active={tab.value === activeTypeTab.value}
              onClick={() => setActiveTypeTab(tab)}
            >
              {tab.title}
            </ControlsButton>
          ))}
        </Controls>
        <Controls>
          {timeTabs.map((tab, index) => (
            <ControlsButton
              key={index}
              active={tab.value === activeTimeTab.value}
              onClick={() => setActiveTimeTab(tab)}
            >
              {tab.title}
            </ControlsButton>
          ))}
        </Controls>
      </TableHeader>
      <Heatmap />
    </>
  );
};

export default DistributionHeatmap;
